import { BookOpen, Award, Users, Clock, Sparkles, TrendingUp } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useTranslation } from "react-i18next";

export const WhyChooseUs = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: BookOpen,
      titleKey: "whyChooseUs.features.unlimitedAccess.title",
      descriptionKey: "whyChooseUs.features.unlimitedAccess.description"
    },
    {
      icon: Award,
      titleKey: "whyChooseUs.features.silvaCoinBonus.title",
      descriptionKey: "whyChooseUs.features.silvaCoinBonus.description"
    },
    {
      icon: Users,
      titleKey: "whyChooseUs.features.prioritySupport.title",
      descriptionKey: "whyChooseUs.features.prioritySupport.description"
    },
    {
      icon: Clock,
      titleKey: "whyChooseUs.features.earlyAccess.title",
      descriptionKey: "whyChooseUs.features.earlyAccess.description"
    },
    {
      icon: Sparkles,
      titleKey: "whyChooseUs.features.certificates.title",
      descriptionKey: "whyChooseUs.features.certificates.description"
    },
    {
      icon: TrendingUp,
      titleKey: "whyChooseUs.features.analytics.title",
      descriptionKey: "whyChooseUs.features.analytics.description"
    }
  ];
  return (
    <section className="py-20 lg:py-32 bg-gradient-to-b from-background via-card/20 to-background relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-secondary/10 rounded-full blur-[100px] -z-10" />
      
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header with proper spacing */}
        <div className="text-center mb-16 space-y-6 max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold">
            <span className="bg-gradient-primary bg-clip-text text-transparent">
              {t('whyChooseUs.title')}
            </span>
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
            {t('whyChooseUs.subtitle')}
          </p>
        </div>

        {/* Features Grid with proper spacing */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <Card
                key={index}
                className="group text-center p-6 hover:scale-105 transition-all duration-300 animate-fade-in"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <CardContent className="space-y-4 p-0">
                  {/* Icon with proper spacing */}
                  <div className="mx-auto w-16 h-16 rounded-2xl bg-gradient-primary flex items-center justify-center shadow-glass group-hover:shadow-glass-hover transition-all duration-300">
                    <Icon className="w-8 h-8 text-primary-foreground" />
                  </div>
                  
                  {/* Title with proper spacing */}
                  <h3 className="text-xl font-semibold text-foreground group-hover:text-primary transition-colors">
                    {t(feature.titleKey)}
                  </h3>
                  
                  {/* Description with proper spacing */}
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {t(feature.descriptionKey)}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
